module.exports = __webpack_public_path__ + "static/img/logo.aacc8bba.png";